<div
  (click)="open()"
  (taAncestorScroll)="close()"
  [taAncestorScrollDisabled]="!opened"
  [class.datepicker--disabled]="disabled"
	#dateLabel
>
  <span class="datepicker-wrapper__label">
    {{ dates.startDate | date: "MMM d, yyyy": "+0000" }}
    <span *ngIf="!single && dates.endDate != null">
      - {{ dates.endDate | date: "MMM d, yyyy": "+0000" }}</span
        >
    </span>
</div>

<ng-template #datepicker>
  <div class="datepicker-wrapper__menu" (taClickOut)="close()">
    <ta-datepicker-inline
      [calendarMonth]="calendarMonth"
      [monthsAhead]="monthsAhead"
      [monthsBehind]="monthsBehind"
      [startInput]="startInput"
      [endInput]="endInput"
      [single]="single"
      [(dates)]="dates"
    >
    </ta-datepicker-inline>
  </div>
</ng-template>
